import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../i18n";

export const FloatingContact = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 right-6 z-50 flex flex-col gap-3"
          data-testid="floating-contact"
        >
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-pill relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-black shadow-lg shadow-[#25D366]/20 hover:scale-110"
            data-testid="whatsapp-float-btn"
            aria-label="WhatsApp"
          >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
            <MessageCircle size={24} />
          </a>
          <a
            href={`tel:${CONTACT.phoneTel}`}
            className="btn-pill flex items-center justify-center w-14 h-14 rounded-full bg-white text-black shadow-lg hover:scale-110"
            data-testid="call-float-btn"
            aria-label="Call"
          >
            <Phone size={22} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
